// DataIdsButton.js
import React, { useState } from 'react';
import DocumentDetailsModal from './DocumentDetailsModal';
import appStyle from "./DataIdModal.module.css";

const DataIdsButton = ({ dataIds, kbId, region }) => {
  const [selectedDataId, setSelectedDataId] = useState(null);

  if (!dataIds || dataIds.length === 0) {
    return null;
  }

  const handleDataIdClick = (dataId) => {
    setSelectedDataId(dataId);
  };

  const handleCloseModal = () => {
    setSelectedDataId(null);
  };

  return (
    <div className={appStyle["data-ids-container"]}>
      {dataIds.map((dataId) => (
        <button
          key={dataId}
          onClick={() => handleDataIdClick(dataId)}
          className={appStyle["data-ids-button"]}
          title={`Click to view document ${dataId}`}
        >
          {dataId}
        </button>
      ))}

      {selectedDataId && (
        <DocumentDetailsModal
          dataId={selectedDataId}
          kbId={kbId}
          region={region}
          onClose={handleCloseModal}
        />
      )}
    </div>
  );
};

export default DataIdsButton;